import React from "react";
import {
  ContactContainer,
  ItemContainer,
  StarSpan,
  LabelContainer,
  ErrorContainer,
  FormContainer,
  CustomizedCountrySelect,
  CustomisedPhoneInput,
  PhoneContainer,
  CustomInput,
} from "../../../myContract/ContactMe.styles";
import styled from "styled-components";
import { Wrapper, StyledImage, TextWrapper,
  TextWrapperSpan, } from "../../../../constants/common/StyledGlobalConstants";
import "./ContactDetailsForm.css";
import { DEVICE_BREAKPOINTS } from "../../../../constants/appConstants";
import VectorIcon from "../../../../assets/icons/External_link.svg";
import CPNotification from "../../../../pages/Login/CPNotification";
import PropTypes from "prop-types";

const { TABLET, DESKTOP } = DEVICE_BREAKPOINTS;

export const BodyTextWrapper = styled(TextWrapper)`
  font-family: neue-haas-grotesk-text;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: ${(props) => props.textAlign};
`;

export const BodyTextWrapperSpan = styled(TextWrapperSpan)`
  font-family: neue-haas-grotesk-text;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  cursor: ${(props) => props.cursor};

  &:hover {
    cursor: ${(props) => props.isLink && "pointer"};
    text-decoration-thickness: ${(props) => props.isLink && "2px"};
  }
  &:focus {
    ${(props) =>
      props.isLink &&
      `
    border-radius: 2px;
    border: 2px solid; 
    outline: none;
  `}
  }
  &:active {
    ${(props) =>
      props.isLink &&
      `
    border: none;
    outline: none; 
    text-decoration-thickness: 0px;
  `}
  }
`;
const ContactDetailsForm = ({
  windowSize,
  contactFormErrorRef,
  firstName,
  lastName,
  email,
  mobileNumber,
  handleNameAndEmailValidation,
  handlePhoneNumberChange,
  handlePhoneNumberOnBlur,
  showContactFormBanner,
  formId,
}) => {

  const isExistingContactForm = formId === "cfst-existing-contact-option";
  const isExitingContactFormValidation = () =>
  [firstName, lastName, email, mobileNumber].some(field => field.showError);
  const shouldShowBanner = () => showContactFormBanner && isExistingContactForm && isExitingContactFormValidation();

  const marginTopVal = () => isExistingContactForm && windowSize.width > TABLET ? "2rem" : ""
  const marginTopValue = () => windowSize.width < TABLET ? "1rem" : "1.5rem";

  const isDESKTOP = windowSize.width >= DESKTOP;
  const isTABLET = windowSize.width >= TABLET;

  return (
    <div style={{ marginTop: marginTopValue(), letterSpacing: "0" }} ref={contactFormErrorRef}>
      <Wrapper display="flex" flexDirection="column" alignItems="flex-start" width="100%">
        <>
          {/* Show confirmation text for existing contact form regardless of selected option */}
          {isExistingContactForm && windowSize.width > TABLET && (
            <Wrapper fontSize="14px" lineHeight="20px" fontWeight="400" fontFamily="neue-haas-grotesk-text">
              {
                "Confirm or update your contact details to ensure you receive your appointment confirmation and any necessary updates from your technician."
              }
            </Wrapper>
          )}

          {/* Orange banner for existing contact form ONLY */}
          {shouldShowBanner() && (           
            <CPNotification isOpen={true} notificationType="cfsterror" closeButton={false} height="auto" >
              <Wrapper display="flex" gap="4px">
                <BodyTextWrapper>
                Your Reveal Contact information is incomplete. You can add the missing details below, but they won't be permanently saved. To permanently update your Reveal account, edit your user details in Reveal. For more, read{' '}
                  <BodyTextWrapperSpan
                    isLink
                    textDecorationLine="underline"
                    cursor="pointer"
                    tabIndex={0}
                    aria-label="Contracts and cancellations FAQ link"
                    id="cfst-appt-details-contract-article-link"
                    onClick={() => window.open("https://reveal-help.verizonconnect.com/hc/articles/17190169888787")}
                  >
                    Creating and editing users
                  </BodyTextWrapperSpan>
                  {". "}
                  <a href="https://reveal-help.verizonconnect.com/hc/articles/17190169888787" target="_blank" aria-hidden="true" tabIndex={-1}>
                    <StyledImage width="12px" height="12px" src={VectorIcon} alt="link" />
                  </a>
                </BodyTextWrapper>
              </Wrapper>
            </CPNotification>
          )}

          <FormContainer
            desktop={isTABLET}
            style={{
              width: "100%",
              marginTop: marginTopVal(),
            }}
          >
            <ContactContainer desktop={isDESKTOP} width="50%" gap="24px">
              <ItemContainer>
                <LabelContainer>
                  <label> {"First name"}</label>
                  <StarSpan>
                    *
                  </StarSpan>
                </LabelContainer>
                <div>
                  <CustomInput
                    id="add-contact-first-name"
                    required={firstName.showError}
                    value={firstName.value}
                    ariaLabel={"First name"}
                    placeholder={"Enter first name"}
                    onChange={(e) => handleNameAndEmailValidation("firstName", e.target.value)}
                    style={{
                      border: firstName.showError 
                        ? '2px solid #FF8C00'
                        : undefined,
                      outline: firstName.showError ? 'none' : undefined
                    }}
                  />
                </div>
                {firstName.showError && (
                  <ErrorContainer role="alert" tabIndex="-1" aria-live="assertive">
                    {firstName.errorText}
                  </ErrorContainer>
                )}
              </ItemContainer>
            </ContactContainer>
            <ContactContainer desktop={isDESKTOP} width="50%">
              <ItemContainer>
                <LabelContainer>
                  <label> {"Last name"}</label>
                  <StarSpan>
                    *
                  </StarSpan>
                </LabelContainer>
                <div>
                  <CustomInput
                    id="add-contact-last-name"
                    required={lastName.showError}
                    value={lastName.value}
                    ariaLabel={"Last name"}
                    placeholder={"Enter last name"}
                    onChange={(e) => handleNameAndEmailValidation("lastName", e.target.value)}
                    style={{
                      border: lastName.showError 
                        ? '2px solid #FF8C00'
                        : undefined,
                      outline: lastName.showError ? 'none' : undefined
                    }}
                  />
                </div>
                {lastName.showError && (
                  <ErrorContainer role="alert" tabIndex="-1" aria-live="assertive">
                    {lastName.errorText}
                  </ErrorContainer>
                )}
              </ItemContainer>
            </ContactContainer>
          </FormContainer>
          <FormContainer desktop={isTABLET} style={{ width: "100%", marginTop: "2rem" }}>
            <ContactContainer desktop={isDESKTOP} width="50%">
              <ItemContainer>
                <LabelContainer>
                  <label> {"Email address"}</label>
                  <StarSpan>*</StarSpan>
                </LabelContainer>
                <div>
                  <CustomInput
                    id="add-contact-email"
                    required={email.showError}
                    value={email.value}
                    aria-label={email.value || "Enter email address"}
                    placeholder={"Enter email address"}
                    onChange={(e) => handleNameAndEmailValidation("email", e.target.value)}
                    tabIndex={0}
                    style={{
                      border: email.showError 
                        ? '2px solid #FF8C00'
                        : undefined,
                      outline: email.showError ? 'none' : undefined
                    }}
                  />
                </div>
                {email.showError && (
                  <ErrorContainer role="alert" tabIndex="-1" aria-live="assertive">
                    {email.errorText}
                  </ErrorContainer>
                )}
              </ItemContainer>
            </ContactContainer>
            <ContactContainer desktop={isDESKTOP} width="50%">
              <ItemContainer>
                <LabelContainer>
                  <label> {"Phone number"}</label>
                  <StarSpan disabled={mobileNumber.isDisabled}>*</StarSpan>
                </LabelContainer>
                <PhoneContainer>
                  <span className="sr-only">International Country Code +1</span>
                  <CustomizedCountrySelect
                    borderRadius="4px 0px 0px 4px"
                    value={"+1"}
                    options={["+1"]}
                    disabled={true}
                    optionLabel="countryCodeWithName"
                    valueTemplate={"+1"}
                    filter
                    resetFilterOnHide
                    id="cfst-mobile-country-code"
                    aria-hidden="true"
                    role="ComboBox"
                  />
                  <CustomisedPhoneInput
                    borderRadius="0px 4px 4px 0px"
                    placeholder={"Enter phone number"}
                    value={mobileNumber.value}
                    phoneNumberDefault={mobileNumber.isDefault}
                    onChange={(e) => {
                      const val = e.target.value.replace(/\D/g, "").slice(0, 10);
                      handlePhoneNumberChange("mobile", val);
                    }}
                    onBlur={(e) => handlePhoneNumberOnBlur("mobile", mobileNumber.value)}
                    disabled={mobileNumber.isDisabled}
                    id="cfst-mobile-number"
                    aria-label={mobileNumber.value || "Enter phone number"}
                    tabIndex={0}
                    style={{
                      border: mobileNumber.showError 
                        ? '2px solid #FF8C00'
                        : undefined,
                      outline: mobileNumber.showError ? 'none' : undefined
                    }}
                  />
                </PhoneContainer>
                {mobileNumber.showError && (
                  <ErrorContainer role="alert" tabIndex="-1" aria-live="assertive">
                    {mobileNumber.errorText}
                  </ErrorContainer>
                )}
              </ItemContainer>
            </ContactContainer>
          </FormContainer>
        </>
      </Wrapper>
    </div>
  );
};

ContactDetailsForm.propTypes = {
  windowSize: PropTypes.object.isRequired,
  contactFormErrorRef: PropTypes.oneOfType([
    PropTypes.func, 
    PropTypes.shape({ current: PropTypes.any })
  ]),
  firstName: PropTypes.shape({
    value: PropTypes.string,
    showError: PropTypes.bool,
    errorText: PropTypes.string
  }).isRequired,
  lastName: PropTypes.shape({
    value: PropTypes.string,
    showError: PropTypes.bool,
    errorText: PropTypes.string
  }).isRequired,
  email: PropTypes.shape({
    value: PropTypes.string,
    showError: PropTypes.bool,
    errorText: PropTypes.string
  }).isRequired,
  mobileNumber: PropTypes.shape({
    value: PropTypes.string,
    showError: PropTypes.bool,
    errorText: PropTypes.string,
    isDisabled: PropTypes.bool,
    isDefault: PropTypes.bool
  }).isRequired,
  handleNameAndEmailValidation: PropTypes.func.isRequired,
  handlePhoneNumberChange: PropTypes.func.isRequired,
  handlePhoneNumberOnBlur: PropTypes.func.isRequired,
  showContactFormBanner: PropTypes.bool,
  formId: PropTypes.string
};

export default ContactDetailsForm;
